import axios from 'axios';
import { React, useState, useContext } from 'react'
import Constants from '../../Constants';
import ConfirmPopup from '../../Utils/ConfirmPopup';
import pdf from "../../images/pdf.png";
import { Spin, Tooltip } from 'antd';
import { UserContext } from '../../Contexts/UserContext';
import { LoadingOutlined } from '@ant-design/icons';
import useModule from '../../hooks/useModule';
import { toast } from 'react-toastify';
import { tearSheetLogUrl, authGenerateUrl, authVerifyUrl } from '../../Config/config';
import { useLocation } from 'react-router';
import useSubmitLog from '../useSumbitLog';

/** The `PdfDownloader` function is a React component that allows the user to download a PDF file. */
function PdfDownloader({ url, data, children, message, fileName = "file", type = "pdf", responseType = "blob" }) {
    const [alert, setAlert] = useState({ show: false, message: message || Constants.excelPopupMessage })
    const { getToken, logout, getUser, authAlert } = useContext(UserContext);
    const [authCode, setAuthCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [reachedLimitPopup, setReachedLimitPopup] = useState({ show: false, message: "" })
    const [isDownloading, setIsDownloading] = useState(false);
    const { primaryMasterId, mappedPrimaryMasterId } = useModule()
    const submitLog = useSubmitLog();

    const onChange = async (flag) => {
        if (authAlert() && flag === 1 && type !== "pdf") {
            setLoading(true)

            try {
                const generateResponse = await axios.post(authGenerateUrl, {}, {
                    headers: {
                        "Authorization": getToken(),
                    },
                });

                if (generateResponse.status === 200) {
                    setReachedLimitPopup({
                        show: true,
                        message: "An authorization code has been sent to your registered email ID. Please enter it below to proceed with data export through the database.",
                    });
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error generating authorization code:", error);
                setLoading(false);
                toast.error("Failed to generate authorization code. Please try again.", { position: "top-center" });
            }
            return;
        }
        if (flag === 1) {
            const result = await downloadExcel()
            if (result === true) {
            } else {
                setReachedLimitPopup({ show: true, message: result })
            }
        }
        setAlert(prev => ({ ...prev, show: false }))
    }

    const downloadExcel = async () => {
        console.log(getUser().email, "iuyi", mappedPrimaryMasterId)
        setIsDownloading(true);
        const result = await axios.post(url, { ...data, type: primaryMasterId },
            {
                responseType: type === "pdf" ? responseType : "blob",
                headers: {
                    "Authorization": getToken()
                }
            }).then(async (response) => {
                setIsDownloading(false);

                const contentType = response.headers['content-type'];

                if (response.status === 200 && contentType === 'application/json') {
                    toast.success(response.data?.message || "The data has been sent to your registered email.", { position: 'top-center' });
                } else if (response.status === 200 && contentType === 'application/pdf') {
                    // Handle PDF download
                    const blob = new Blob([response.data], { type: contentType });
                    const href = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', `${fileName}.${type}`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);

                    if (children === "Tear Sheet") {
                        submitLog("TS")
                    }
                } else if (response.status === 200) {
                    // Fallback for other valid content types
                    const href = URL.createObjectURL(response.data);
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', `${fileName}.${type}`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                }
                return true;
            }).catch(async (error) => {
                setIsDownloading(false);

                if (error?.response?.status === Constants.sessionTerminatedStatus) {
                    logout();
                } else if (error?.response?.status === 400) {
                    const contentType = error?.response?.headers['content-type'];

                    if (contentType === "application/json") {
                        const dataAsText = await error?.response?.data?.text();
                        const parsedData = JSON.parse(dataAsText);
                        return parsedData?.message;
                    } else {
                        const dataAsText = await error?.response?.data?.text();
                        return dataAsText || "An error occurred while exporting.";
                    }
                }
            });
        return result
    }


    const handleAuthCodeSubmit = async (code) => {
        try {
            // Step 3: Call authVerifyUrl API with the entered code
            const verifyResponse = await axios.post(authVerifyUrl, { authCode: code }, {
                headers: {
                    "Authorization": getToken(),
                },
            });

            if (verifyResponse.status === 200) {
                console.log(verifyResponse, "Authorization code verified successfully");
                // Step 4: Show success message and proceed with export
                toast.success(verifyResponse?.data?.message, { position: "top-center" });
                localStorage.setItem(Constants.localStorageKeys.exportExpireAt, verifyResponse?.data?.export_expires_at);

                setReachedLimitPopup({ show: false, message: "" });

                // Trigger Excel download
                const result = await downloadExcel()
                    if (result === true) {
                    } else {
                        setReachedLimitPopup({ show: true, message: result })
                    }
                    setAlert(prev => ({ ...prev, show: false }))
            }
        } catch (error) {
            console.error("Error verifying authorization code:", error.response?.data?.message);
            toast.error(error?.response?.data?.message, { position: "top-center" });
        }
    };
    if (reachedLimitPopup.show ) {
        if(authAlert()){
            return (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-10">
                    <div className="relative w-full max-w-lg mx-4 md:mx-0 bg-white rounded-lg shadow-xl">
                        {/* Header */}
                        <div className="pt-5 px-5 flex justify-between items-center">
                            <h1 className="text-lg font-bold text-gray-900">Authorization Required</h1>
                            <button
                                onClick={() => setReachedLimitPopup({ show: false, message: "" })}
                                className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
                            >
                                &times;
                            </button>
                        </div>
    
                        {/* Body */}
                        <div className="p-5">
                            <p className="text-sm text-gray-500">{reachedLimitPopup.message}</p>
                            <div className="mt-4 pl-4 flex items-center gap-2">
                                <input
                                    type="text"
                                    maxLength={8}
                                    placeholder="52974198"
                                    className="w-28 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#BC8B20]"
                                    onChange={(e) => setAuthCode(e.target.value)}
                                />
                                <button
                                    onClick={() => handleAuthCodeSubmit(authCode)}
                                    className="px-4 py-2 text-sm font-medium text-white bg-[#BC8B20] rounded-md shadow-sm hover:bg-[#a37517] focus:outline-none"
                                    disabled={authCode.length !== 8}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
    
            );
        }else{
            return <div className='flex font-sans_book_body cursor-default justify-center items-center z-10 fixed left-0 top-0 w-screen h-screen  bg-gray-500 bg-opacity-75 transition-opacity'>
            <div className='relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 mx-4 md:mx-0 w-[50%]'>
                <div className='w-full flex flex-col '>
                    <div className="mt-3 text-center sm:mt-0 px-5 py-3 sm:ml-4 sm:text-left">
                        <h1 className='text-left py-1 text-lg font-bold leading-6 text-gray-900'>Alert!</h1>
                        <div className="mt-4 ">
                            <p className="text-sm text-gray-500 text-start">{reachedLimitPopup.message}</p>
                        </div>
                    </div>
                </div>
                <div className='flex bg-gray-50 px-4 pb-3 flex-row-reverse'>
                    <button onClick={() => setReachedLimitPopup(prev => ({ ...prev, show: false }))} className='inline-flex w-full justify-center font-sans_bold_body rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none  sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'>
                        Close
                    </button>
                </div>
            </div>
        </div>
        }
    }

    return (
        <div>
            <ConfirmPopup {...alert} onChange={onChange} icon={<></>} loading={loading} activeBtnName={isDownloading ? "Downloading" : "Download"} closeBtnName='Close' title='Select option for pdf file export' disable={isDownloading} />
            {isDownloading
                ? <Spin indicator={<LoadingOutlined style={{ fontSize: 26, color: "#BC8B20", }} spin />} />
                : 
                // <Tooltip title="Export">
                    <span onClick={() => setAlert(prev => ({ ...prev, show: true }))}>
                        {children || <img src={pdf} className="cursor-pointer   h-[24px] w-[21px] " alt="" />}
                    </span>
                // </Tooltip>
            }
        </div>

    )
}

export default PdfDownloader